import api from "../../../api";

export default {
  async getWeatherDaily({ commit }, filter) {
    commit("REQUEST_WEATHERDAILY");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_WEATHERDAILY",
        await api.getWeatherDaily(filter)
      );
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_WEATHERDAILY");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async getLocationPVForecast({ commit }, filter) {
    commit("REQUEST_PV_FORECAST");
    commit("SET_LOADING", true, { root: true });
    try {
      const response = await api.getLocationPVForecast(filter);
      commit("SUCCESS_REQUEST_PV_FORECAST", response);
      return response.body;
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      commit("FAILURE_REQUEST_PV_FORECAST");
      return [];
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
};
